<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { useGlobalStore } from "@/shared/model";
import { ArrowIcon, UiButton } from "@/shared/ui";

const { t } = useI18n({ useScope: "global" });
const globalStore = useGlobalStore();
</script>

<template>
    <UiButton color="ghost" @click="globalStore.backToPrevStep">
        <ArrowIcon />
        {{ t("common.back") }}
    </UiButton>
</template>
